var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[(_vm.library_id)?_c('factory-list'):_vm._e(),_c('detail-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }